
import { memo } from "react";
import { IIconsProps } from "./icons.model";

const File = (props: IIconsProps) => {
    return (
        <i id={props.id} className='fa-solid fa-file' style={{ fontSize: props.fontSize, color: props.color }} />
    );
};

export default memo(File);

